import React, { useState, useEffect, useContext } from 'react';
import './DeploymentResourceForm.css';
import { getResourceDetailsById, createResourceDeploy, getIncidentRegions, facilityListByRegionId } from '../../../../Services/EndPoints';
import { getData, postDataWithBody } from '../../../../Services/Services';
import Select from 'react-select';
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { ThemeContext } from '../../../..';


const DeploymentResourceForm = ({ resouceData, onResourceDetailsUpdate, onLocateOnMap }) => {
   const [formData, setFormData] = useState({
      searchResource: '',
      resourceId: '',
      resourceName: '',
      incidentName: '',
      agencyName: '',
      agencyWebsite: '',
      agencyContacts: [],
      totalQuantity: '',
      availableQuantity: '',
      deployQuantity: '',
      locationName: '',
      latitude: '',
      longitude: '',
      locateOnMap: false,
      facilityNames: '',
      incidentId: '',
   });
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState(null);
   const [contactOptions, setContactOptions] = useState([]);
   const [quantityError, setQuantityError] = useState('');
   const [deploySuccess, setDeploySuccess] = useState(false); // New state for deployment success
   const navigate = useNavigate();
   const [incidentRegions, setIncidentRegions] = useState([]);
   const { theme } = useContext(ThemeContext);
   // const [facilityNames, setFacilityNames] = useState([
   //   { value: 'flood_relief_camp', label: 'Flood Relief Camp' },
   //   { value: 'community_kitchen', label: 'Community Kitchen' },
   //   { value: 'animal_shelter', label: 'Animal Shelter' },
   // ]);


   const [facilityNames, setFacilityNames] = useState([]);
   const [isDeploying, setIsDeploying] = useState(false);


   const handleFacilityNamesChange = (e) => {
      setFormData(prev => ({
         ...prev,
         facilityNames: e.target.value
      }));
   };
   const OptionWithCheckbox = ({ innerProps, isSelected, label }) => (
      <div {...innerProps} className="d-flex p-2" style={{
         backgroundColor: isSelected ? '#f0f0f0' : '#fff',
         color: '#333',
         cursor: 'pointer',
         alignItems: 'flex-start', // Align items to top
         minHeight: '40px' // Ensure consistent height
      }}>
         <div style={{
            marginRight: '12px', // Increased spacing between checkbox and text
            marginTop: '2px', // Fine-tuned vertical alignment
            flexShrink: 0 // Prevent checkbox from shrinking
         }}>
            <input
               type="checkbox"
               checked={isSelected}
               readOnly
               style={{
                  verticalAlign: 'top',
                  cursor: 'pointer',
                  width: '16px',
                  height: '16px'
               }}
            />
         </div>
         <div style={{
            flex: 1,
            paddingTop: '1px' // Minor adjustment for perfect alignment
         }}>
            {label.split('\n').map((line, i) => (
               <div key={i}>{line}</div> // Handle multi-line content
            ))}
         </div>
      </div>
   );


   const MultiValue = ({ data }) => (
      <span className="mr-1" style={{color: theme === 'dark' ? 'white' : '#333'}}>{data.label}</span>
   );


   const MultiValueContainer = ({ children }) => (
      <div className="d-flex flex-wrap align-items-center" style={{ maxWidth: '100%', gap: '4px' }}>
         {React.Children.map(children, (child, index) => (
            <>
               {child}
               {index < React.Children.count(children) - 1 && (
                  <span style={{
                     color: '#7c8091',
                     fontSize: '14px',
                     padding: '0 2px'
                  }}>|</span>
               )}
            </>
         ))}
      </div>
   );


   const handleResourceSelect = async (e) => {
      const selectedResourceId = e.target.value;

      setFormData(prev => ({
         ...prev,
         searchResource: selectedResourceId
      }));

      if (!selectedResourceId) {
         setFormData(prev => ({
            ...prev,
            incidentName: '',
            incidentId: '',
            resourceName: '',
            resourceId: '',
            agencyName: '',
            agencyWebsite: '',
            agencyContacts: [],
            totalQuantity: '',
            availableQuantity: '',
            deployQuantity: '',
            locationName: '',
            latitude: '',
            longitude: ''
         }));
         setContactOptions([]);
         setQuantityError('');
         return;
      }


      const selectedResource = resouceData.find(resource => resource.id.toString() === selectedResourceId);

      try {
         setLoading(true);
         setError(null);

         const payload = {
            incidentId: selectedResource.incidentId,
            ids: [parseInt(selectedResourceId)]
         };
         // const resourceDetailsResponse = await postDataWithBody(getResourceDetailsById, [selectedResourceId], {});
         const resourceDetailsResponse = await postDataWithBody(getResourceDetailsById, payload, {});
         console.log("Resource Details Response", resourceDetailsResponse);


         // Second API call - get incident regions      
         const incidentRegionsResponse = await getData(`${getIncidentRegions}${selectedResource.incidentId}`);
         console.log("Incident Regions Response", incidentRegionsResponse);

         // Store the incident regions data
         setIncidentRegions(incidentRegionsResponse);

         const resourceDetails = resourceDetailsResponse[0];

         const contacts = resourceDetails.resource_contact_map?.map(contactMap => {
            const contactDetails = contactMap.contact_details || {};
            const contactName = contactDetails.name || '';
            const contactPhone = contactDetails.phone1 || '';
            const jobTitle = contactDetails.job_title_config?.value || '';

            let contactText = '';
            if (contactName && jobTitle && contactPhone) {
               contactText = `${contactName}, ${jobTitle}, ${contactPhone}`;
            } else if (contactName && contactPhone) {
               contactText = `${contactName}, ${contactPhone}`;
            } else {
               contactText = contactPhone || '';
            }

            return {
               value: contactMap.id,
               label: contactText,
               contactId: contactMap.contact_id // Store the actual contact ID for deployment
            };
         }) || [];


         if (contacts.length === 0 && resourceDetails.agency_details?.phone) {
            contacts.push({
               value: 'agency_phone',
               label: resourceDetails.agency_details.phone,
               contactId: null // No contact ID for agency phone
            });
         }

         const regionId = resourceDetails.resource_region_map?.[0]?.region_id;
         if (regionId) {
            try {
               const facilityResponse = await getData(`${facilityListByRegionId}${regionId}`);
               console.log("Facility Response", facilityResponse);

               const formattedFacilities = facilityResponse.map(facility => ({
                  value: facility.id,
                  label: facility.name
               }));

               setFacilityNames(formattedFacilities);

               // Set the first facility as default if available
               if (formattedFacilities.length > 0) {
                  setFormData(prev => ({
                     ...prev,
                     facilityNames: formattedFacilities[0].value
                  }));
               }
            } catch (err) {
               console.error('Error fetching facilities:', err);
               setFacilityNames([]);
            }
         } else {
            setFacilityNames([]);
         }


         setContactOptions(contacts);


         const formattedResourceName = `${resourceDetails.name || selectedResource?.name || ''} (${resourceDetails.agency_details?.name || ''})`;


         const updatedFormData = {
            ...formData,
            searchResource: selectedResourceId,
            resourceId: resourceDetails.id || '',
            incidentId: selectedResource.incidentId,
            resourceName: resourceDetails.name || selectedResource?.name || '',
            incidentName: resourceDetails.incident_name || '',
            agencyName: resourceDetails.agency_details?.name || '',
            agencyWebsite: resourceDetails.agency_details?.website || '',
            agencyContacts: contacts.length > 0 ? [contacts[0]] : [],
            totalQuantity: resourceDetails.total_quantity || '',
            availableQuantity: resourceDetails.available_quantity !== undefined ? resourceDetails.available_quantity : '',
            deployQuantity: '',
            locationName: resourceDetails.facility_name || '',
            latitude: '',
            longitude: ''
         };

         setFormData(updatedFormData);
         setQuantityError('');

         if (onResourceDetailsUpdate) {
            onResourceDetailsUpdate(resourceDetails, incidentRegionsResponse);
         }
      } catch (err) {
         setError('Failed to fetch resource details');
         console.error('Error fetching resource details:', err);
      } finally {
         setLoading(false);
      }
   };


   const handleContactChange = (selectedOptions) => {
      setFormData(prev => ({
         ...prev,
         agencyContacts: selectedOptions || []
      }));
   };


   const handleInputChange = (e) => {
      const { name, value, type, checked } = e.target;

      if (name === 'deployQuantity') {
         const intValue = Math.floor(Number(value));
         if (value.includes('.') || isNaN(intValue)) {
            setQuantityError('Please enter a whole number');
            return;
         }
         const availableQty = parseInt(formData.availableQuantity) || 0;
         const deployQty = parseInt(value) || 0;

         if (deployQty > availableQty) {
            setQuantityError(`Deploy quantity cannot exceed available quantity (${availableQty})`);
         } else if (deployQty <= 0) {
            setQuantityError('Deploy quantity must be greater than 0');
         } else {
            setQuantityError('');
         }
      }

      setFormData(prev => ({
         ...prev,
         [name]: type === 'checkbox' ? checked : value
      }));
   };


   const handleLocateOnMap = () => {
      console.log('Locate on map clicked');
      if (formData.resourceId) {
         onLocateOnMap(incidentRegions); // Pass incidentRegions to the parent handler
      } else {
         toast.warning("Please select a resource first", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
         });
      }
   };



   const handleDeploy = async () => {
      if (quantityError) {
         return;
      }
      setIsDeploying(true);
      const availableQty = parseInt(formData.availableQuantity) || 0;
      const deployQty = parseInt(formData.deployQuantity) || 0;

      if (deployQty > availableQty) {
         setQuantityError(`Deploy quantity cannot exceed available quantity (${availableQty})`);
         setIsDeploying(false);
         return;
      }

      if (deployQty <= 0) {
         setQuantityError('Deploy quantity must be greater than 0');
         setIsDeploying(false);
         return;
      }

      if (!formData.facilityNames) {
         toast.error("Please select a deploy facility", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
         });
         return;
      }

      const facilityId = parseInt(formData.facilityNames);
      if (isNaN(facilityId)) {
         toast.error("Invalid facility selection", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
         });
         setIsDeploying(false);
         return;
      }

      // Prepare the payload
      const payload = {
         resourceId: parseInt(formData.resourceId),
         deploy_quantity: deployQty,
         deploy_facility_id: facilityId,
         incident_id: parseInt(formData.incidentId),
         resource_deploy_contact_map: formData.agencyContacts
            .filter(contact => contact.contactId)
            .map(contact => ({
               contact_id: contact.contactId
            }))
      };


      try {
         setLoading(true);
         setError(null);

         // Call the deployment endpoint
         const response = await postDataWithBody(createResourceDeploy, payload, {});

         console.log('Deployment successful:', response);


         // Show toast based on response status
         if (response.status === "success") {
            toast.success(response.msg || "Resource deployed successfully", {
               position: toast.POSITION.TOP_CENTER,
               autoClose: 2000,
            });
            setLoading(false);
            setTimeout(() => {
               navigate("/resource-assign-list");
            }, 3000);
         } else {
            toast.error(response.msg || "Resource already deployed", {
               position: toast.POSITION.TOP_CENTER,
               autoClose: 2000,
            });
            setIsDeploying(false);
         }

      } catch (err) {
         console.error('Error deploying resource:', err);
         toast.error(err.response?.data?.msg || "Failed to deploy resource", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
         });
         setIsDeploying(false);
      } finally {
         setLoading(false);
      }
   };



   const inputReadOnly = {
      borderRadius: "0.1rem",
      border: "1px solid #7c8091",
      backgroundColor: "var(--secondary-color)",
      color: "#7c8091",
      fontSize: "12px",
      fontWeight: 200
   };


   const customSelectStyles = {
      control: (provided, state) => ({
         ...provided,
         backgroundColor: "none",
         borderColor: state.isFocused ? '#4d90fe' : '#dddde0ff',
         boxShadow: state.isFocused ? '0 0 0 1px #4d90fe' : null,
         '&:hover': {
            borderColor: '#4d90fe'
         },
         minHeight: '29px',
         height: '29px',
         borderRadius: '4px',
         cursor: 'text',
         color: 'white',
         borderRadius: "2px"
      }),
      valueContainer: (provided) => ({
         ...provided,
         flexWrap: 'nowrap',
         overflow: 'hidden',
         textOverflow: 'ellipsis',
         whiteSpace: 'nowrap',
         cursor: 'text',
         padding: '0 8px',
         input: {
            color: 'white !important',
            cursor: 'text !important'
         }
      }),
      multiValue: (provided) => ({
         ...provided,
         backgroundColor: 'transparent',
         border: 'none',
         margin: '0 2px',
         padding: 0
      }),
      multiValueLabel: (provided) => ({
         ...provided,
         color: 'inherit',
         padding: 0,
         cursor: 'text'
      }),
      multiValueRemove: () => ({
         display: 'none'
      }),
      input: (provided) => ({
         ...provided,
         color: 'white',
         width: 'auto',
         cursor: 'text !important',
         margin: 0,
         padding: 0
      }),
      placeholder: (provided) => ({
         ...provided,
         color: 'rgba(163, 160, 160, 0.7)',
         margin: 0
      }),
      singleValue: (provided) => ({
         ...provided,
         color: 'white',
         margin: 0
      }),
      menu: (provided) => ({
         ...provided,
         zIndex: 9999,
         backgroundColor: '#fff',
         color: '#333'
      }),
      option: (provided, state) => ({
         ...provided,
         backgroundColor: state.isSelected ? '#f0f0f0' : '#fff',
         color: '#333',
         '&:hover': {
            backgroundColor: '#e0e0e0'
         }
      }),
      dropdownIndicator: (provided) => ({
         ...provided,
         padding: '4px'
      }),
      clearIndicator: (provided) => ({
         ...provided,
         padding: '4px'
      })
   };


   return (
      <div className="resource-form-container" style={{
         backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44", // white for light, dark for dark
         padding: "1rem",
         borderRadius: "8px",
      }}>
         <h3 className="resource-details" style={{ color: theme === 'dark' ? 'white' : '#333' }}>Resource Details</h3>

         {error && <div className="alert alert-danger">{error}</div>}
         {deploySuccess && <div className="alert alert-success">Resource deployed successfully!</div>}

         <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
            <div style={{ width: '400px' }}>
               <select
                  name="searchResource"
                  value={formData.searchResource}
                  onChange={handleResourceSelect}
                  className={theme == "light"?"search-input1":"search-input"}
                  style={{ width: "400px" }}
                  disabled={loading}
               >
                  <option value="">Select Resource...</option>
                  {resouceData && resouceData.map(resource => (
                     <option key={resource.id} value={resource.id}>
                        {`${resource.name} (${resource.agency_name})`}
                     </option>
                  ))}
               </select>
            </div>
         </div>

         <div className="text-center">
            <button className="btn rd-locate-map-btn" onClick={handleLocateOnMap}>
               Locate On Map
            </button>
         </div>


         <div className="row" style={{ marginTop: '2rem' }}>
            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="incidentName">Incident Name:</label>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="incidentName"
                     name="incidentName"
                     value={formData.incidentName}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
               </div>
            </div>

            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="resourceName">Resource Name:</label>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="resourceName"
                     name="resourceName"
                     value={formData.resourceName}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="agencyName">Agency Name:</label>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="agencyName"
                     name="agencyName"
                     value={formData.agencyName}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                     <label className="rd-label" htmlFor="locationName">Resource Facility Name:</label>
                  </div>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="locationName"
                     name="locationName"
                     value={formData.locationName}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="agencyContacts">Agency Contact:</label>
                  <Select
                     isMulti
                     name="agencyContacts"
                     options={contactOptions}
                     className={theme === "light" ? "rd-custom-select__control1" : "rd-custom-select__control"}
                     value={formData.agencyContacts}
                     onChange={handleContactChange}
                     placeholder="Select contacts..."
                     components={{
                        Option: OptionWithCheckbox,
                        MultiValue,
                        MultiValueContainer
                     }}
                     hideSelectedOptions={false}
                     closeMenuOnSelect={false}
                      styles={customSelectStyles}
                     isClearable={false}
                     backspaceRemovesValue={false}
                  />
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="totalQuantity">Total Quantity:</label>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="totalQuantity"
                     name="totalQuantity"
                     value={formData.totalQuantity}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="availableQuantity">Available Quantity:</label>
                  <input
                     readOnly
                     type="text"
                     className="rd-form-control"
                     id="availableQuantity"
                     name="availableQuantity"
                     value={formData.availableQuantity}
                     onChange={handleInputChange}
                     style={inputReadOnly}
                  />
                  {parseInt(formData.availableQuantity) === 0 && (
                     <div className="text-danger small mt-1">No resources available for deployment</div>
                  )}
               </div>
            </div>


            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="deployQuantity">Deploy Quantity: <span style={{ color: "red" }}>*</span></label>
                  <input
                     type="number"
                     className={theme === "light" ? "rd-form-control1" : "rd-form-control"}
                     id="deployQuantity"
                     name="deployQuantity"
                     value={formData.deployQuantity}
                     onChange={handleInputChange}
                     min="1"
                     max={formData.availableQuantity}
                     step="1" // This ensures only whole numbers
                     onKeyDown={(e) => {
                        // Prevent decimal point entry
                        if (e.key === '.' || e.key === ',') {
                           e.preventDefault();
                        }
                     }}
                     disabled={parseInt(formData.availableQuantity) === 0}
                     style={{
                        ...(parseInt(formData.availableQuantity) === 0 && {
                           borderColor: '#7c8091',
                           cursor: 'not-allowed'
                        })
                     }}
                  />
                  {quantityError && (
                     <div className="text-danger small mt-1">{quantityError}</div>
                  )}
                  {parseInt(formData.availableQuantity) === 0 && (
                     <div className="text-danger small mt-1">No resources available for deployment</div>
                  )}
               </div>
            </div>
            <div className="col-md-6 mb-3">
               <div className="form-group">
                  <label className="rd-label" htmlFor="facilityNames">Deploy Facility Name: <span style={{ color: "red" }}>*</span></label>
                  <select
                     className={theme === "light" ? "rd-form-control1" : "rd-form-control"}
                     id="facilityNames"
                     name="facilityNames"
                     value={formData.facilityNames}
                     onChange={handleFacilityNamesChange}
                  >
                     <option value="">Select a category</option>
                     {facilityNames.map(facility => (
                        <option key={facility.value} value={facility.value}>
                           {facility.label}
                        </option>
                     ))}
                  </select>
               </div>
            </div>
         </div>


         <div className="text-center" style={{ marginTop: "1rem" }}>
            <button
               className="btn rd-locate-map-btn"
               onClick={handleDeploy}
               style={{ backgroundColor: theme === 'light' ? '#252b48' : '',}}
               disabled={
                  !!quantityError ||
                  !formData.deployQuantity ||
                  !formData.facilityNames ||
                  loading ||
                  formData.availableQuantity === '0' ||
                  parseInt(formData.availableQuantity) === 0 ||
                  isDeploying
               }
            >
               {loading ? 'Deploying...' : 'Deploy'}
            </button>
         </div>
      </div>
   );
};


export default DeploymentResourceForm;
